<template>
  <div class="graduate-apply-form">
    <!-- 学生基本信息 -->
    <div class="card student-info-card">
      <div class="card-header">
        <h3>学生基本信息</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>学生姓名</label>
            <div class="form-value">{{ studentInfo.stuName }}</div>
          </div>
          <div class="form-item">
            <label>学号</label>
            <div class="form-value">{{ studentInfo.stuNo }}</div>
          </div>
          <div class="form-item">
            <label>校外教学点</label>
            <div class="form-value">{{ studentInfo.siteName }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>专业</label>
            <div class="form-value">{{ studentInfo.proName }}</div>
          </div>
          <div class="form-item">
            <label>层次</label>
            <div class="form-value">{{ studentInfo.learnLevel }}</div>
          </div>
          <div class="form-item">
            <label>前置学历是否通过</label>
            <div class="form-value" :class="studentInfo.preEducationPass == 1 ? 'success' : 'error'">
              {{ studentInfo.preEducationPass_dictText }}
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>学历照片是否通过</label>
            <div class="form-value" :class="studentInfo.educationImg == 1 ? 'success' : 'error'">
              {{ studentInfo.educationImg_dictText }}
            </div>
          </div>
          <div class="form-item"></div>
          <div class="form-item"></div>
        </div>
      </div>
    </div>

    <!-- 论文相关 -->
    <div class="card thesis-info-card">
      <div class="card-header">
        <h3>论文相关</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>论文初稿上传时间</label>
            <div class="form-value">{{ studentInfo.draftUploadTime }}</div>
          </div>
          <div class="form-item">
            <label>论文终稿上传时间</label>
            <div class="form-value">{{ studentInfo.finalUploadTime }}</div>
          </div>
          <div class="form-item" v-if="applyType === 0">
            <label>是否申请学位</label>
            <div class="form-value" :class="studentInfo.applyDegree == 1 ? 'success' : 'error'">
              {{ studentInfo.applyDegree_dictText }}
            </div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>评阅成绩</label>
            <div class="form-value">{{ studentInfo.finalScore }}</div>
          </div>
          <div class="form-item">
            <label>总评成绩</label>
            <div class="form-value">{{ studentInfo.thesisScore }}</div>
          </div>
          <div class="form-item">
            <label>答辩成绩</label>
            <div class="form-value">{{ studentInfo.defenseScore }}</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平均成绩及学分 -->
    <div class="card score-info-card">
      <div class="card-header">
        <h3>平均成绩及学分</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>论文或社会调查已获学分</label>
            <div class="form-value">{{ studentInfo.thesisCredit }}</div>
          </div>
          <div class="form-item">
            <label>专业实习已获学分</label>
            <div class="form-value">{{ studentInfo.practiceCredit }}</div>
          </div>
          <div class="form-item">
            <label>平均成绩</label>
            <div class="form-value">{{ studentInfo.avgScore }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>选修课已获学分</label>
            <div class="form-value">{{ studentInfo.electiveCredit }}</div>
          </div>
          <div class="form-item">
            <label>必修课程已获学分</label>
            <div class="form-value">{{ studentInfo.compulsoryCredit }}</div>
          </div>
          <div class="form-item">
            <label>已修学分</label>
            <div class="form-value">{{ studentInfo.completedCredit }}</div>
          </div>
        </div>
        <div class="form-row">
          <div class="form-item">
            <label>学分完成情况</label>
            <div class="form-value" :class="studentInfo.creditStatus == 1 ? 'success' : 'error'">
              {{ studentInfo.creditStatus_dictText }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 学费 -->
    <div class="card tuition-info-card">
      <div class="card-header">
        <h3>学费</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item">
            <label>应缴学费金额</label>
            <div class="form-value">{{ studentInfo.payableAmount }}</div>
          </div>
          <div class="form-item">
            <label>已缴学费金额</label>
            <div class="form-value">{{ studentInfo.paidAmount }}</div>
          </div>
          <div class="form-item">
            <label>欠费金额</label>
            <div class="form-value">{{ studentInfo.arrearsAmount }}</div>
          </div>
        </div>

        <div class="form-actions" v-if="applyType == 1">
          <a-button
            type="primary"
            class="btn-submit"
            @click="submit"
            v-if="studentInfo.finalStatus === 0 || studentInfo.finalStatus === 5 || studentInfo.finalStatus === 3 || studentInfo.finalStatus === 7"
          >
            提交申请
          </a-button>
        </div>
      </div>
    </div>

    <!-- 申请信息 -->
    <div class="card apply-form-card" v-if="applyType !== 1">
      <div class="card-header">
        <h3>申请信息</h3>
      </div>
      <div class="card-body">
        <div class="form-row">
          <div class="form-item" v-if="studentInfo.foreignLanguageExempt == 0">
            <label>学位外语成绩</label>
            <div class="form-value">{{ studentInfo.foreignLanguageScore }}</div>
          </div>
          <div class="form-item">
            <label>学位外语是否免考</label>
            <div class="form-value" :class="studentInfo.foreignLanguageExempt == 1 ? 'success' : 'error'">
              {{ studentInfo.foreignLanguageExempt_dictText }}
            </div>
          </div>
        </div>
        <!-- 当学位外语是否免考为是，或者已经上传了免考证书时，显示免考证书上传部分 -->
        <!-- <div class="form-row" v-if="studentInfo.learnLevel === '专升本' || studentInfo.learnLevel === '高起本'"> -->
        <div class="form-row">
          <div class="form-item" style="flex: 1; min-width: 100%" v-if="studentInfo.foreignLanguageExempt == 1">
            <label>
              免考证书证明材料
              <span style="color: red">*</span>
            </label>
            <div class="upload-container">
              <CommonUpload
                ref="exemptUploadRef"
                :hideTip="false"
                :disabled="!isEditable"
                :accept="'.jpg,.jpeg,.png,.pdf'"
                :listType="'picture'"
                :maxCount="1"
                @success="onExemptUploadSuccess"
                @remove="onExemptFileRemove"
              />
            </div>
          </div>
        </div>
        <div v-if="applyType == 2">
          <div class="form-row">
            <div class="form-item">
              <label>
                是否已有毕业证
                <span style="color: red">*</span>
              </label>
              <div class="form-value">
                <a-radio-group v-model="hasGraduateCert" :disabled="!isEditable" style="display: flex; flex-direction: row; gap: 16px;">
                  <a-radio :value="1">是</a-radio>
                  <a-radio :value="0">否</a-radio>
                </a-radio-group>
              </div>
            </div>
            <div class="form-item">
              <div v-if="hasGraduateCert == 1">
                <label>
                  毕业时间
                  <span style="color: red">*</span>
                </label>
                <div class="form-value">
                  <a-date-picker v-model="graduateTime" :disabled="!isEditable" format="YYYY-MM-DD" placeholder="请选择毕业时间" style="width: 100%" />
                </div>
              </div>
            </div>
          </div>
          <div class="form-row" v-if="hasGraduateCert == 1">
            <div class="form-item">
              <label>
                毕业证书证明材料
                <span style="color: red">*</span>
              </label>
              <div class="upload-container">
                <CommonUpload
                  ref="certUploadRef"
                  :hideTip="false"
                  :disabled="!isEditable"
                  :accept="'.jpg,.jpeg,.png,.pdf'"
                  :listType="'picture'"
                  :maxCount="1"
                  @success="onCertUploadSuccess"
                  @remove="onCertFileRemove"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <a-button
            type="primary"
            class="btn-submit"
            @click="submit"
            v-if="studentInfo.finalStatus === 0 || studentInfo.finalStatus === 5 || studentInfo.finalStatus === 3 || studentInfo.finalStatus === 7"
          >
            提交申请
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonUpload from '@/common/components/CommonUpload.vue';

export default {
  name: 'graduateApplyForm',
  components: {
    CommonUpload,
  },
  props: {
    applyType: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      uploadingName: '',
      uploadingList: '',
      // 毕业证相关字段（applyType=2）
      hasGraduateCert: null,
      graduateCertImg: '',
      graduateTime: null,
      certUploadingName: '',
      certUploadingList: '',
      studentInfo: {},
      loading: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
      },
    };
  },
  computed: {
    // 提交按钮可见时表单可编辑，隐藏时禁止编辑
    isEditable() {
      return [0, 3, 5, 7].includes(this.studentInfo.finalStatus);
    },
  },
  created() {
    this.getData();
  },
  methods: {
    // ==================== 免考证书上传事件 ====================
    onExemptUploadSuccess({ file, response }) {
      if (response && response.result) {
        this.uploadingList = response.result;
        this.uploadingName = file.name;
      }
    },
    onExemptFileRemove({ fileList }) {
      if (!fileList || fileList.length === 0) {
        this.uploadingList = '';
        this.uploadingName = '';
      }
    },
    // ==================== 毕业证书上传事件 ====================
    onCertUploadSuccess({ file, response }) {
      if (response && response.result) {
        this.certUploadingList = response.result;
        this.certUploadingName = file.name;
      }
    },
    onCertFileRemove({ fileList }) {
      if (!fileList || fileList.length === 0) {
        this.certUploadingList = '';
        this.certUploadingName = '';
      }
    },
    getData() {
      this.loading = true;
      this.axios
        .get(`/degree/stuDegree/stuGraInfo?type=apply&applyType=${this.applyType}`)
        .then(res => {
          this.loading = false;
          if (res && res.code === 200 && res.result) {
            this.studentInfo = res.result;
            // 初始化毕业证相关字段（applyType=2）
            if (this.applyType === 2) {
              this.hasGraduateCert = this.studentInfo.hasGraduateCert;
              this.graduateCertImg = this.studentInfo.graduateCertImg || '';
              this.graduateTime = this.studentInfo.graduateTime || null;
              // 恢复毕业证照片上传状态
              if (this.graduateCertImg) {
                const fileName = this.graduateCertImg.split('/').pop();
                this.certUploadingList = this.graduateCertImg;
                this.certUploadingName = fileName;
                // 等渲染完成后再设置文件列表
                this.$nextTick(() => {
                  if (this.$refs.certUploadRef) {
                    this.$refs.certUploadRef.setFileList([
                      {
                        name: fileName,
                        status: 'done',
                        url: this.graduateCertImg,
                      },
                    ]);
                  }
                });
              }
            }
            // 检查是否有已上传的免考证书
            if (this.studentInfo.exemptionCertificate && this.studentInfo.exemptionCertificate !== null) {
              const fileName = this.studentInfo.exemptionCertificate.split('/').pop();
              this.uploadingList = this.studentInfo.exemptionCertificate;
              this.uploadingName = fileName;
              this.$nextTick(() => {
                if (this.$refs.exemptUploadRef) {
                  this.$refs.exemptUploadRef.setFileList([
                    {
                      name: fileName,
                      status: 'done',
                      url: this.studentInfo.exemptionCertificate,
                    },
                  ]);
                }
              });
            }
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('获取学生信息失败:', error);
          this.$message.error('获取学生信息失败，请稍后重试');
        });
    },
    submit() {
      // applyType=0 学位外语免考校验
      if (this.applyType == 0 || this.applyType == 2) {
        if (this.studentInfo.foreignLanguageExempt == 1 && (!this.uploadingName || !this.uploadingList)) {
          this.$message.error('学位外语免考时必须上传免考证书证明材料');
          return;
        }
      }
      // applyType=2 学位申请校验
      if (this.applyType == 2) {
        if (this.hasGraduateCert === null) {
          this.$message.error('请选择是否已有毕业证');
          return;
        }
        if (this.hasGraduateCert == 1) {
          if (!this.graduateTime) {
            this.$message.error('请选择毕业时间');
            return;
          }
          if (!this.certUploadingList) {
            this.$message.error('请上传毕业证书证明材料');
            return;
          }
        }
      }
      let params = {
        applyType: this.applyType,
      };

      // 免考证书路径（后台通过 exemptionCertificate 字段接收）
      if (this.uploadingName && this.uploadingList) {
        params.exemptionCertificate = this.uploadingList;
      }

      // applyType=2 时携带毕业证相关字段
      if (this.applyType == 2) {
        params.hasGraduateCert = this.hasGraduateCert;
        params.firstApplyGraduateCert = this.hasGraduateCert == 0 ? 1 : 0;
        params.graduateCertImg = this.hasGraduateCert == 1 ? this.certUploadingList : null;
        params.graduateTime = this.hasGraduateCert == 1 ? this.graduateTime : null;
      }

      this.axios
        .post(`/degree/stuDegree/submitApply`, params)
        .then(res => {
          if (res && res.code === 200) {
            this.$message.success('提交成功');
            // 重新获取学生信息，包括已上传的文件
            this.getData();
          } else {
            this.$message.error((res && res.message) || '提交失败，请稍后重试');
          }
        })
        .catch(error => {
          console.error('提交申请失败:', error);
          this.$message.error('提交失败，请稍后重试');
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.graduate-apply-form {
  background: #f5f5f5;
  padding: 20px;
  margin-top: 20px;
}

.card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  overflow: hidden;
}

.card-header {
  background: #fafafa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
}

.card-header h3 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.card-body {
  padding: 24px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -12px;
  margin-bottom: 16px;
}

.form-row:last-child {
  margin-bottom: 0;
}

.form-item {
  flex: 1;
  min-width: 250px;
  padding: 0 12px;
  margin-bottom: 16px;
}

.form-item label {
  display: block;
  font-size: 14px;
  color: #999;
  margin-bottom: 8px;
}

.form-item .form-value {
  font-size: 14px;
  color: #333;
  padding: 8px 12px;
  background: #fafafa;
  border-radius: 4px;
  min-height: 32px;
  display: flex;
  align-items: center;
}

.form-item .success {
  color: #52c41a;
}

.form-item .error {
  color: #ff4d4f;
}

.form-item .status {
  color: #1890ff;
}

.upload-container {
  width: 100%;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
  padding: 4px 12px;
  background: #fafafa;
  margin-top: 8px;

  &:hover {
    border-color: #2caf7a;
  }
}

.form-actions {
  display: flex;
  justify-content: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #e8e8e8;
}

.btn-submit {
  background: #2caf7a;
  color: #fff;
  width: 120px;
  height: 36px;
  font-size: 14px;
}

.btn-submit:hover {
  background: #259d8a;
  border-color: #259d8a;
}

@media (max-width: 768px) {
  .form-row {
    flex-direction: column;
  }

  .form-item {
    min-width: 100%;
  }

  .card-body {
    padding: 16px;
  }

  .card-header {
    padding: 12px 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/graduateApplyTabs/apply.vue